import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "side-menu-container col-md-3 p-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "my-3" }, "Κατηγορία", -1)
const _hoisted_5 = { class: "content-container col-md-9" }
const _hoisted_6 = { class: "my-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Αντικείμενα ")
const _hoisted_8 = { class: "text-muted initialism" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_side_menu = _resolveComponent("side-menu")!
  const _component_content = _resolveComponent("content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_side_menu, { onSelectCategory: _ctx.onSelectCategory }, null, 8, ["onSelectCategory"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h5", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.itemsNum === null ? '' : `(${_ctx.itemsNum})`), 1)
        ]),
        _createVNode(_component_content, {
          selectedCategoryId: _ctx.selectedCategoryId,
          onItemsCountChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.itemsNum = $event))
        }, null, 8, ["selectedCategoryId"])
      ])
    ])
  ]))
}